import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-6">
        <i className="ri-error-warning-line text-3xl text-foreground-300"></i>
      </div>
      <div className="relative z-10">
        <h1 className="text-6xl md:text-8xl font-heading font-bold text-foreground-200 select-none">404</h1>
        <p className="text-xl md:text-2xl font-medium text-foreground-800 mt-4">页面未找到</p>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-block mt-6 bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-2.5 rounded-full text-sm cursor-pointer transition-colors"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}